import React from "react";

export function Footer({ weekKey }) {
  return (
    <></>
  );
}
